<template>
  <div class="app">
    <h1>制度设计和员工培训</h1>
    <Header :activeIndex="'1-3'" />

    <main class="margintop">
      <section>
        <div class="biaoti">1.招聘制度</div>
        <div class="content">(1) 公司招聘流程包括岗位发布、简历筛选、面试以及最后的入职流程，确保选拔到合适的人才。</div>
        <div class="content">(2) 招聘要求包括学历要求、相关工作经验、岗位所需技能要求等</div>
      </section>
      <section>
        <div class="biaoti">2.薪酬制度</div>
        <div class="content">(1) 基本薪资结构包括基础工资、绩效奖金、年终奖、股权激励等多项收入，充分激励员工积极性。</div>
        <div class="content">(2) 薪资调整机制基于年度绩效评估、员工表现优异可获得加薪或职位晋升等激励。</div>
      </section>
      <section>
        <div class="biaoti">3.管理制度</div>
        <div class="content">(1) 公司管理层分为高级管理层、中层管理层和基层管理层，各层级有明确的职责和分工。</div>
        <div class="content">(2) 管理考核标准包括绩效评估，团队目标达成情况、个人贡献等，确保目标的高效实现。</div>
      </section>
      <section>
        <div class="biaoti">4.财务制度</div>
        <div class="content">(1) 财务报销流程分为审批、报销、财务审核和付款等环节，确保资金使用的合规和透明。</div>
        <div class="content">(2) 预算管理包括部门预算编制、财务审核、执行监控等，确保预算合理分配和使用。</div>
      </section>
      <section>
        <div class="biaoti">5.组织架构优化</div>
        <div class="content">(1) 组织结构优化分析包括各部门职能分工与人员配置等情况，立秋提升整体工作效率。</div>
        <div class="content">(2) 优化方案包括阻止充足、职能整合、跨部门协作改进等，确保公司运行更加高效流畅。</div>
      </section>
      <section>
        <div class="biaoti">6.运营流程优化</div>
        <div class="content">(1) 现有运营流程涵盖产品开发到市场推广、销售及客户服务的各个环节，确保顺畅运营。</div>
        <div class="content">(2) 优化措施包括减少冗余步骤、提高效率以及应用自动化工具来提升整体工作效率。</div>
      </section>
      <section>
        <div class="biaoti">7.驻场诊断</div>
        <div class="content">(1) 驻场工作目标是现场诊断问题、发现潜在风险，并提出切实可行的解决方案以推动改进。</div>
        <div class="content">(2) 驻场工作内容包括进行现场调研、员工访谈、流程分析等，帮助发现流程瓶颈和优化点。</div>
      </section>
      <section>
        <div class="biaoti">8.培训体系建设</div>
        <div class="content">(1) 培训目标是提升员工的专业能力、管理技能以及团队协作能力，推动个人和团队共同成长。</div>
        <div class="content">(2) 培训内容包括岗位技能培训、管理技能提升培训、跨部门合作技巧等，增强员工综合素质。</div>
      </section>
    </main>

    <Youshi />
    <Footer />
  </div>
</template>
  
  
<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Youshi from '@/components/Youshi.vue'

export default {
  name: 'xinxi',
  components: {
    Header,
    Footer,
    Youshi
  },
  data() {
    return {
      imgCount: 0,
      currentIndex: 0,
      intervalID: '',
      // showData: true,
      pppclose: true,
      row1: ['注册<br>公司', '不续费<br>地址', '代理<br>记账', '社保<br>托管', '刻章<br>补照'],
      row2: ['变更<br>注销', '审计<br>咨询', '资质<br>许可', '商标<br>软著', '税务<br>筹划']
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    // console.log(this.$root.showData.showData);
    this.$root.showData.showData = false;
  },
  methods: {
    formatText(text) {
      return text;
    },
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathRemen() {
      this.$router.push('/remen');
    },
    pathJizhang() {
      this.$router.push('/jizhang')
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxueyuan() {
      this.$router.push('/xueyuan');
    },
    pathcontact() {
      this.$router.push('/contact')
    },
    pathxinxi() {
      this.$router.push('/xinxi')
    },
  }
}
</script>
  
<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {
  .responsive-carousel el-carousel el-carousel--horizontal {
    height: 128px !important;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }

  .el-menu--horizontal>.el-menu-item {
    float: left;
    height: 30px !important;
    line-height: 30px !important;
    margin: 0;
  }
}
</style>
  
<style scoped>
h1 {
  font-size: 0%;
}

.biaoti {
  font-size: 20px;
  font-weight: 700;
  margin-top: 10px;
  line-height: 30px;
}

.content {
  font-size: 17px;
  line-height: 35px;
}

.margintop {
  text-align: left;
  margin-left: 25%;
  margin-right: 25%;
  font-size: 25px;
  margin-top: 118px;
  font-weight: 500;
}

@media (max-width: 768px) {

  /* 图片 */
  .biaoti {
    font-size: 15px;
    font-weight: 700;
  }

  .content {
    margin-top: 5px;
    color: black;
    line-height: normal;
    font-size: 13px;
    font-weight: 400;
  }

  /* 其他 */
  .margintop {
    margin-top: 100px;
    text-align: left;
    margin-left: auto;
    margin-right: auto;
    font-size: 15px;
    margin-left: 2%;
    margin-right: 2%;
    margin-bottom: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/zhidu.vue